/*
 * File: ApptCalendarDialog.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Displays calendar dialog to select which day to view in Schedule
 */
import React, { useState } from "react";
import { Calendar } from "@material-ui/pickers";
import { Dialog, Button, Theme, createStyles } from "@material-ui/core";
import { withStyles } from "@material-ui/styles";
import { WithStyles } from "@material-ui/core";

const styles = (theme: Theme) =>
  createStyles({
    button: {
      color: theme.palette.common.white,
      background: theme.palette.common.buttonGradient
    },
    dialogPaper: {
      margin: theme.spacing(2),
      // without hiding overflow, the animation causes a scroll bar to appear and jump around a bit until the animation finishes.
      overflow: "hidden"
    }
  });

interface Props extends WithStyles<typeof styles> {
  open: boolean;
  onClose: () => void;
  onSelect: (date: Date | null) => void;
}

const ApptCalendarDialog = ({ classes, open, onClose, onSelect }: Props) => {
  const [value] = useState(new Date());

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{ className: classes.dialogPaper }}
    >
      <Calendar date={value} onChange={onSelect} />
      <Button
        size="large"
        color="primary"
        className={classes.button}
        fullWidth
        variant="contained"
        onClick={() => onSelect(null)}
      >
        Go To Today
      </Button>
    </Dialog>
  );
};

export default withStyles(styles)(ApptCalendarDialog);
